// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_45-0";
export var eligibilityCardNotEligible = "_45-1";